<template>
  <draggable
    ref="drag"
    v-model="unallocated"
    v-bind="dragOptions"
    multi-drag
    selected-class="multi-drag"
    @update="onUpdate"
    @add="onAdd"
    @remove="onRemove"
    @start="onDragStart"
    @end="onDragEnd"
    style="min-height: 520px"
  >
    <cargo-card
      v-for="cargo in virtualCargosList"
      :key="cargo.id"
      :isCollapsed="isCollapsed"
      :unallocatedCargo="cargo"
      :selected="selectedCargo[cargo.id]"
      :isDragable="true"
      @update:selected="$emit('update:selected', cargo.id)"
      :class="{ selected: selectedCargo[cargo.id] }"
    />
    <div v-if="unallocated.length" v-observe-visibility="handleCargosScroll"></div>
    <div class="d-flex justify-center align-center py-3" v-if="unallocated.length == 0">Nenhuma carga encontrada</div>
  </draggable>
</template>

<script>
import CargoCard from '@/components/ManualBoardingImport/Stepper/Step6/CargoCard.vue';
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
    CargoCard
  },
  props: {
    cargos: {
      type: Array,
      default: () => []
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    selectedCargo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dragOptions: {
        animation: 150,
        group: 'cargosAllocation',
        ghostClass: 'ghost',
        disabled: false,
        handle: '.handle-drag'
      },
      isDragging: false,
      cargosToShow: 10
    };
  },
  computed: {
    unallocated: {
      get() {
        return this.cargos;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    },
    localSelectedCargo: {
      get() {
        return this.selectedCargo;
      },
      set(newVal) {
        this.$emit('update:selectedCargo', newVal);
      }
    },
    virtualCargosList() {
      return this.unallocated.slice(0, this.cargosToShow);
    }
  },

  methods: {
    onDragStart(e) {
      this.isDragging = true;
      e.item._selected_items = this.unallocated.filter((f) => this.localSelectedCargo[f.id]);
    },
    onDragEnd() {
      this.isDragging = false;
    },
    onUpdate(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
        unallocated.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocated = unallocated;
      }
    },
    onRemove(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        this.unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
      }
    },
    onAdd(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
        unallocated.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocated = unallocated;
      }
    },
    handleCargosScroll(isVisible) {
      if (!isVisible || this.cargosToShow >= this.unallocated.length) return;
      this.cargosToShow += 5;
    }
  }
};
</script>
<style scoped>
.ghost {
  display: none;
}
</style>
